<template>
	<fieldset id="fs-CAspec" class="pt-5 pb-5">
		<div class="container">
			<div class="row justify-content-end align-items-center">
				<button
					type="button"
					:class="['js-btn-toggle', formData.CAspec && 'toggled']"
					@click.prevent="handleToggle"
					ref="button"
				>
					<i class="toggle-knob"></i>

					<span class="label">California Specification Mode</span>
				</button>

				<Tooltip
					:title="inputConfig.CAspec.label"
					:description="inputConfig.CAspec.desc"
					align="left"
				>
					<p>
						This toggle sets the selection of your inputs to match the inputs given in the CA Compliance Software CBECC-Res 19.1.2, by aligning the hot water draws, the occupancy ratios, and the supply temperature.
					</p>
				</Tooltip>
			</div>
		</div>
	</fieldset>
</template>

<script>
import Tooltip from '@/components/Tooltip'
import formData from '@/components/Sizer/form-data-store'
import inputConfig from '@/components/FormInput/input-config'

export default {
	name: 'CASpecToggle',

	components: {
		Tooltip,
	},

	data: () => ({
		formData,
		inputConfig,
	}),

	methods: {
		handleToggle () {
			const { $refs: { button } } = this

			formData.CAspec = !formData.CAspec
			formData.inputmethod = 'RPep'
			formData.caBedroom = formData.CAspec
			formData.RBR_presets = 'CA'
			formData.gpdppptionsBR = formData.caBedroom ? 'ca' : 'user'
			formData.supplyT = 125

			button.blur()
		}
	}
}
</script>
